import {Form, Formik} from 'formik';
import Header from 'modules/header/farm/main';
import {useState} from 'react';
import {QualifyFormSchema} from './utilities/validationSchema';
import {qualifyInitialValues} from './utilities/initialValues';
import {useNavigate, useParams} from 'react-router-dom';
import {existingUnits} from 'utilities/helper/existingUnitsOption';
import EditQualityFormComponent from 'components/forms/editQuality';
import {useWholesaler} from 'context/wholesaler';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import DotsLoading from 'components/loadings/dotsLoading';

const EditQualityForm = () => {
  const {guid} = useParams();
  const {productDetail, isLoading} = useGetPostDetail(guid || '');

  const {
    wholesaler,
    uploadQualifyForm,
    updateTypePost,
    updateSubProduct,
    setDeleteOldImages,
  } = useWholesaler();
  const [images, setImages] = useState<IUploadImage[]>(
    wholesaler?.images ? wholesaler?.images : [],
  );
  const navigate = useNavigate();

  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      {isLoading ? (
        <DotsLoading />
      ) : (
        <Formik
          initialValues={qualifyInitialValues({
            existing: productDetail?.existing?.toString(),
            existing_unit: productDetail?.existing_unit,
          })}
          validationSchema={QualifyFormSchema}
          onSubmit={values => {
            const qualifyData = {
              images,
              existing_unit: values?.existing_unit,
              existing: values?.existing,
            };
            uploadQualifyForm(qualifyData);
            updateTypePost(productDetail?.type || '');
            navigate(`/wholesaler/edit/owner/${guid || ''}`);
            productDetail?.product?.guid &&
              updateSubProduct(productDetail?.subproduct?.guid);
          }}
        >
          <Form className="pb-[7vh]">
            <EditQualityFormComponent
              removeImage={setDeleteOldImages}
              mainImageGuid={productDetail?.main_image?.guid || ''}
              images={images}
              setImages={setImages}
              oldImages={productDetail?.images?.filter(
                item => !wholesaler?.deleted_images?.includes(item?.guid),
              )}
              existingUnits={existingUnits}
            />
          </Form>
        </Formik>
      )}
    </>
  );
};

export default EditQualityForm;
